export default {
  section_title: 'Devise',
  label: 'Devise',
  tooltip:
    'La devise utilisée pour vos prix, versements et rapports. Elle est définie pour votre compte partenaire à sa création et ne peut pas être modifiée ici — contactez le support si elle est incorrecte.',
  from_your_partner: 'Depuis votre partenaire',
  set_for_your_account: 'Définie pour votre compte',
};
